'use strict';

var cov_kbbzok1ij = function () {
  var path = 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\ads\\ads.js',
      hash = '769bfe313115697df8e4d6b6dededb9e159915c2',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\ads\\ads.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 30
        }
      },
      '1': {
        start: {
          line: 4,
          column: 20
        },
        end: {
          line: 9,
          column: 5
        }
      },
      '2': {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 33,
          column: 7
        }
      },
      '3': {
        start: {
          line: 16,
          column: 20
        },
        end: {
          line: 16,
          column: 22
        }
      },
      '4': {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 28,
          column: 9
        }
      },
      '5': {
        start: {
          line: 18,
          column: 10
        },
        end: {
          line: 27,
          column: 11
        }
      },
      '6': {
        start: {
          line: 19,
          column: 12
        },
        end: {
          line: 24,
          column: 13
        }
      },
      '7': {
        start: {
          line: 20,
          column: 29
        },
        end: {
          line: 20,
          column: 42
        }
      },
      '8': {
        start: {
          line: 21,
          column: 14
        },
        end: {
          line: 23,
          column: 15
        }
      },
      '9': {
        start: {
          line: 22,
          column: 16
        },
        end: {
          line: 22,
          column: 142
        }
      },
      '10': {
        start: {
          line: 26,
          column: 12
        },
        end: {
          line: 26,
          column: 83
        }
      },
      '11': {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 29,
          column: 29
        }
      },
      '12': {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 32,
          column: 48
        }
      },
      '13': {
        start: {
          line: 37,
          column: 0
        },
        end: {
          line: 42,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 88
          },
          end: {
            line: 34,
            column: 3
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 31,
            column: 12
          },
          end: {
            line: 31,
            column: 13
          }
        },
        loc: {
          start: {
            line: 31,
            column: 20
          },
          end: {
            line: 33,
            column: 5
          }
        },
        line: 31
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 18,
            column: 10
          },
          end: {
            line: 27,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 18,
            column: 10
          },
          end: {
            line: 27,
            column: 11
          }
        }, {
          start: {
            line: 18,
            column: 10
          },
          end: {
            line: 27,
            column: 11
          }
        }],
        line: 18
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0
    },
    f: {
      '0': 0,
      '1': 0
    },
    b: {
      '0': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdsController = function AdsController($scope, moment, $http, apiOpen, $stateParams, $window, myVars, $location) {
  _classCallCheck(this, AdsController);

  cov_kbbzok1ij.f[0]++;
  cov_kbbzok1ij.s[0]++;

  $scope.checkinfo = myVars;
  var dataObj = (cov_kbbzok1ij.s[1]++, {
    mm: $stateParams.mm,
    package: $stateParams.package,
    cp: $stateParams.cpid,
    curl: $location.absUrl()
  });
  cov_kbbzok1ij.s[2]++;
  $http({
    method: 'POST',
    url: apiOpen + 'ads/makeurl',
    data: dataObj,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    transformRequest: function transformRequest(obj) {
      var str = (cov_kbbzok1ij.s[3]++, []);
      cov_kbbzok1ij.s[4]++;
      for (var key in obj) {
        cov_kbbzok1ij.s[5]++;

        if (obj[key] instanceof Array) {
          cov_kbbzok1ij.b[0][0]++;
          cov_kbbzok1ij.s[6]++;

          for (var idx in obj[key]) {
            var subObj = (cov_kbbzok1ij.s[7]++, obj[key][idx]);
            cov_kbbzok1ij.s[8]++;
            for (var subKey in subObj) {
              cov_kbbzok1ij.s[9]++;

              str.push(encodeURIComponent(key) + '[' + idx + '][' + encodeURIComponent(subKey) + ']=' + encodeURIComponent(subObj[subKey]));
            }
          }
        } else {
          cov_kbbzok1ij.b[0][1]++;
          cov_kbbzok1ij.s[10]++;

          str.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
        }
      }
      cov_kbbzok1ij.s[11]++;
      return str.join('&');
    }
  }).then(function (data) {
    cov_kbbzok1ij.f[1]++;
    cov_kbbzok1ij.s[12]++;

    $window.location.href = data.data.message;
  });
};

cov_kbbzok1ij.s[13]++;


angular.module('app').component('ads', {
  templateUrl: 'app/ads/ads.html',
  controller: AdsController
});